import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const BesseggenLogo: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 35 35">
        <path
            d="M16.2857 7.06881H14V21.2992C14 24.0986 16.3025 26.368 19.1429 26.368C21.9832 26.368 24.2857 24.0986 24.2857 21.2992C24.2857 18.4997 21.9832 16.2304 19.1429 16.2304L21.4286 13.7818L19.1429 10.5983C25.1391 10.5983 30 15.3893 30 21.2992C30 27.2091 25.1391 32 19.1429 32C13.1466 32 8.28571 27.2091 8.28571 21.2992V7.06881H6L10.8571 2L16.2857 7.06881Z"
            fill="#FF453A"
        />
    </SvgIcon>
)

export default BesseggenLogo
